<template>
  <div class="text-no-wrap" @click.right.prevent="clickComDireito" @dblclick="selecionarDataAposDuploClique">
    {{ data_atual }}

    <v-icon v-if="EXIBIR_ICONE_SELECAO" :size="15" title="Data está sendo usada na comparação">
      mdi-compare
    </v-icon>

    <v-menu
      v-model="menu_ativo"
      :position-x="posicao_click.x"
      :position-y="posicao_click.y"
      :close-on-content-click="false"
      transition="scale-transition"
    >
      <div class="bg-white" @mouseover="cancelarFechamentoDoMenu" @mouseout="fecharMenuAposDelay">
        <div class="d-flex align-center pt-1 pb-2px pl-2 pr-1">
          <v-icon :size="20" class="mr-1 mt-n1px">mdi-select-compare</v-icon>
          <span class="font-16 font-weight-medium ml-1">Comparação Entre Datas</span>

          <v-spacer />

          <v-btn icon @click="menu_ativo = false">
            <v-icon :size="22">mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="d-flex align-center px-2 pt-1 pb-2">
          <div class="w-160">
            <v-text-field
              v-model="data_atual"
              label="Primeira Data"
              hide-details
              disabled
              outlined
              dense
            />
          </div>

          <div class="w-160 ml-2">
            <v-select
              v-model="data_final_selecionada"
              label="Segunda Data"
              :items="outras_datas"
              hide-details
              outlined
              dense
            />
          </div>

          <v-btn
            :disabled="data_final_selecionada === null"
            color="#0a3950"
            :dark="data_final_selecionada !== null"
            class="ml-2"
            @click="atualizarDadasSelecionadas"
          >
            salvar
          </v-btn>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "SelecionarDatasParaComparacao",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: Object,
    data_atual: String,
    outras_datas: Array,
  },
  data: () => ({
    menu_ativo: false,
    data_final_selecionada: null,
    posicao_click: {
      x: 0,
      y: 0,
    },
    timer_delay_para_fechar_menu: null,
  }),
  computed: {
    EXIBIR_ICONE_SELECAO() {
      return Object.values(this.modelValue).includes(this.data_atual) && this.data_atual !== '00/00/0000';
    }
  },
  watch: {
    menu_ativo() {
      if (this.menu_ativo && this.modelValue.data_final && this.outras_datas.includes(this.modelValue.data_final)) {
        this.data_final_selecionada = this.modelValue.data_final;
      } else {
        this.data_final_selecionada = null;
      }
    }
  },
  methods: {
    clickComDireito({x, y}) {
      this.posicao_click = {x: x - 5, y: y - 5};
      this.menu_ativo = true;
    },
    atualizarDadasSelecionadas() {
      this.$emit("update:modelValue", {
        data_inicial:  this.data_atual,
        data_final: this.data_final_selecionada,
      });

      this.menu_ativo = false;
    },
    fecharMenuAposDelay() {
      clearTimeout(this.timer_delay_para_fechar_menu);
      this.timer_delay_para_fechar_menu = setTimeout(() => this.menu_ativo = false, 10000);
    },
    cancelarFechamentoDoMenu() {
      clearTimeout(this.timer_delay_para_fechar_menu);
    },
    selecionarDataAposDuploClique() {
      if (this.data_atual === this.modelValue.data_final) return;

      this.data_final_selecionada = this.modelValue.data_final;
      this.atualizarDadasSelecionadas();
    }
  }
}
</script>

<style scoped>

</style>
